export const lightColors = {
  primary: {
    main: "#ffc600",
    light: "#ffe81c",
    dark: "#ebac00",
  },
  secondary: {
    main: "#312D3B",
    light: "#4e4959",
    dark: "#24212b",
  },
  border: {
    light: "#edeef0",
    main: "#CFCFCF",
    dark: "#B2B2B2",
  },
  background: {
    light: "#FAFCFC",
    main: "#FAFCFC",
    dark: "#FAFCFC",
  },
};

export const darkColors = {
  primary: {
    main: "#ffc600",
    light: "#ffe81c",
    dark: "#ebac00",
  },
  secondary: {
    main: "#312D3B",
    light: "#4e4959",
    dark: "#24212b",
  },
  border: {
    light: "#3c3b3b",
    main: "#2e2d2d",
    dark: "#121111",
  },
  background: {
    light: "#3c3b3b",
    main: "#121111",
    dark: "#0c0b0b",
  },
};
